import React, {useState, useContext} from "react";
import cn from "classnames";
import OutsideClickHandler from "react-outside-click-handler";
import styles from "./Actions.module.sass";
import Transfer from "../Transfer";
import RemoveSale from "../RemoveSale";
import Burn from "../Burn";
import Icon from "../Icon";
import Modal from "../Modal";
import PutSale from "../PutSale";
import {Web3Context} from "../../contexts/Web3Context";
import PlaceABid from "../PlaceABid";
import {message} from 'antd';

message.config({top: 100, duration: 5, maxCount: 3,});

const Actions = ({className, item, users}) => {
  const [visible, setVisible] = useState(false);
  const [visibleModalTransfer, setVisibleModalTransfer] = useState(false);
  const [visibleModalRemoveSale, setVisibleModalRemoveSale] = useState(false);
  const [visibleModalBurn, setVisibleModalBurn] = useState(false);
  const [visibleModalPutOnSale, setVisibleModalPutOnSale] = useState(false);

  const {defaultAccount} = useContext(Web3Context);

  const menuItems = [
    {
      title: "Put on sale",
      icon: "bag",
      hidden: item.in_sale !== null,
      action: () => setVisibleModalPutOnSale(true),
    },
    {
      title: "Remove from sale",
      icon: "close-circle",
      hidden: item.in_sale === null,
      action: () => setVisibleModalRemoveSale(true),
    },
    {
      title: "Transfer token",
      icon: "arrow-right-square",
      hidden: item.in_sale !== null,
      action: () => setVisibleModalTransfer(true),
    },
    {
      title: "Burn token",
      icon: "close-circle",
      hidden: item.in_sale !== null,
      action: () => setVisibleModalBurn(true),
    },
  ];

  return (
    <>
      {defaultAccount === item.currentOwner &&
      <>
        <OutsideClickHandler onOutsideClick={() => setVisible(false)}>
          <div className={cn(styles.actions, className, {[styles.active]: visible,})}>
            <button className={cn("button-circle-stroke", styles.button)} onClick={() => setVisible(!visible)}>
              <Icon name="more" size="24"/>
            </button>
            <div className={styles.body}>
              {menuItems.map((x, index) => (
                <div className={styles.item} key={index} onClick={x.action} hidden={x.hidden}>
                  <Icon name={x.icon} size="20"/>
                  <span>{x.title}</span>
                </div>
              ))}
            </div>
          </div>
        </OutsideClickHandler>

        <Modal visible={visibleModalPutOnSale} onClose={() => setVisibleModalPutOnSale(false)} onClickOutside={() => {
        }}>
          <PutSale item={item} onOutsideClick={() => setVisibleModalPutOnSale(false)}/>
        </Modal>
        <Modal visible={visibleModalRemoveSale} onClose={() => setVisibleModalRemoveSale(false)}>
          <RemoveSale item={item} onOutsideClick={() => setVisibleModalRemoveSale(false)}/>
        </Modal>
        <Modal visible={visibleModalTransfer} onClose={() => setVisibleModalTransfer(false)}>
          <Transfer item={item} onOutsideClick={() => setVisibleModalTransfer(false)}/>
        </Modal>
        <Modal visible={visibleModalBurn} onClose={() => setVisibleModalBurn(false)}>
          <Burn item={item} onOutsideClick={() => setVisibleModalBurn(false)}/>
        </Modal>
      </>}
      {defaultAccount !== item.currentOwner && <>
        {item.price && <PlaceABid item={item} users={users}/>}
      </>}
    </>
  );
}

export default Actions;
